import { handleResponse } from '../handleResponse';
import { SessionConfig, SessionStateResponse } from './types';

export class SessionStateApiBaseClient {
  private readonly endpoint: string;

  constructor(url = '') {
    this.endpoint = `${url}/v2`;
  }

  public async me(): Promise<SessionStateResponse> {
    const response = await fetch(`${this.endpoint}/me`);
    return await handleResponse(response);
  }

  public async getConfig(): Promise<SessionConfig> {
    const response = await fetch(`${this.endpoint}/config`);
    return await handleResponse(response);
  }
}

export const SessionStateApiClient = new SessionStateApiBaseClient();
